import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';
import _ from 'lodash';

import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import useAlerts from 'utils/hooks/useAlerts';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';
import { ResourceType } from 'utils/types';
import { org2providerClients } from './queries';
import RelationTable from 'components/RelationTable/RelationTable';
import useRelations from 'utils/hooks/useRelations';
import { useRelationData, createRelationQueryData, createOrgOwnerRelationQueryData } from './queries';
import { providerClientKeys } from 'components/Admin/Providers/queries';


const OrgToProviderClientsRelations = ({ breadcrumbs }) => {
  const api = useAPI();
  const { orgId, providerId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const [providerClientsQuery, relationQuery, ownerQuery] = useQueries({
    queries: [
      { queryKey: providerClientKeys.clients(providerId), queryFn: createQueryRequest(api.core.getProviderClients) },
      { queryKey: org2providerClients.org(createRelationQueryData(ResourceType.ProviderClient, orgId)), queryFn: createQueryRequest(api.core.findRelationships) },
      { queryKey: org2providerClients.org(createOrgOwnerRelationQueryData(ResourceType.ProviderClient)), queryFn: createQueryRequest(api.core.findRelationships) }
    ]
  });

  // Add providerId to providerClients as the relationId is a merged id
  const updatedProviderClients = useMemo(() => {
    return _.map(providerClientsQuery.data, (providerClient) => {
      return {
        ...providerClient,
        id: `${providerId}::${providerClient.id}`
      };
    });
  }, [providerClientsQuery.data, providerId]);

  const providerClients = useRelationData({
    isLoading: providerClientsQuery.isLoading || relationQuery.isLoading || ownerQuery.isLoading,
    resources: updatedProviderClients,
    resourceRelations: relationQuery.data,
    ownedRelations: ownerQuery.data,
    resourceType: ResourceType.ProviderClient
  });

  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: relationQuery.refetch,
    queryKey: org2providerClients.org(createRelationQueryData(ResourceType.ProviderClient)),
    onError: addErrorAlert
  });

  return (
    <ContentPage
      breadcrumb={breadcrumbs}
    >
      { alerts }
      <RelationTable
        orgId={orgId}
        resources={providerClients}
        isLoading={providerClientsQuery.isLoading || relationQuery.isLoading || ownerQuery.isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />
    </ContentPage>
  );
};

export default OrgToProviderClientsRelations;
